<div class="content wz-form-step">

  <div class="wz-head">
    <span class="wz-eyebrow">World Creation Wizard</span>
    <h2 class="wz-title">{{ mapName }} <span class="gold">global context</span></h2>
    <span class="wz-step">Part 3 of 3</span>
  </div>

  <div class="scroll-container flex-grow-1 px-3">
    <!-- Form Layout -->
    <div class="form-container mx-auto">

      <!-- Prominent Guilds Row -->
      <div class="form-row mb-4">
        <label for="prominentGuilds" class="form-label fw-bold">Prominent guilds (one per line) <span class="req">*</span></label>
        <div class="input-wrapper flex-grow-1">
          <textarea id="prominentGuilds" class="form-textarea" rows="3" [(ngModel)]="prominentGuilds"
            placeholder="Ironwright Consortium - Controls metalwork, siege engines, and fortress construction"
          [class.is-invalid]="showErrorMsg && !prominentGuilds.trim()"></textarea>
        </div>
      </div>

      <!-- Guild Density Dropdown -->
      <div class="form-row mb-3">
        <label for="guildDensity" class="form-label fw-bold">Guild density <span class="req">*</span></label>
        <div class="select-wrapper flex-grow-1">
          <ng-select class="wt-select" id="guildDensity" [(ngModel)]="selectedDensity" [class.is-invalid]="showErrorMsg && !selectedDensity" [items]="densities"
            placeholder="Choose…" [clearable]="false" appendTo="body">
            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
          </ng-select>
        </div>
      </div>

      <!-- Guild Culture Dropdown -->
      <div class="form-row mb-3">
        <label for="guildCulture" class="form-label fw-bold">Guild culture <span class="req">*</span></label>
        <div class="select-wrapper flex-grow-1">
          <ng-select class="wt-select" id="guildCulture" [(ngModel)]="selectedCulture" [class.is-invalid]="showErrorMsg && !selectedCulture" [items]="cultures"
            placeholder="Choose…" [clearable]="false" appendTo="body">
            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
          </ng-select>
        </div>
      </div>

      <!-- Guild Volatility Dropdown -->
      <div class="form-row mb-3">
        <label for="guildVolatility" class="form-label fw-bold">Guild volatility <span class="req">*</span></label>
        <div class="select-wrapper flex-grow-1">
          <ng-select class="wt-select" id="guildVolatility" [(ngModel)]="selectedVolatility" [class.is-invalid]="showErrorMsg && !selectedVolatility" [items]="volatilities"
            placeholder="Choose…" [clearable]="false" appendTo="body">
            <ng-template ng-label-tmp let-label="label"><span [class.wt-select-hint]="!label">{{ label || 'Choose…' }}</span></ng-template>
          </ng-select>
        </div>
      </div>

    </div>

    <!-- Validation Error Banner -->
    @if (showErrorMsg) {
      <div class="error-banner mb-3 mx-auto">
        <span class="error-text">{{ validationErrorText }}</span>
      </div>
    }

  </div>

  <div class="wz-actions">
    <button type="button" class="btn btn-dark" (click)="onBack()">Back</button>
    <button type="button" class="btn btn-theme" (click)="onNext()">Next</button>
  </div>

</div>
